import { render, staticRenderFns } from "./DealTable.vue?vue&type=template&id=77697e31&scoped=true"
import script from "./DealTable.vue?vue&type=script&lang=js"
export * from "./DealTable.vue?vue&type=script&lang=js"
import style0 from "./DealTable.vue?vue&type=style&index=0&id=77697e31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77697e31",
  null
  
)

export default component.exports